import React, { useEffect, createElement } from 'react';
import { NorthvilleHeroInfo } from './northville/NorthvilleHeroInfo';
import { NorthvilleHeroForm } from './northville/NorthvilleHeroForm';
import { NorthvilleDistance } from './northville/NorthvilleDistance';
import { NorthvilleWhy } from './northville/NorthvilleWhy';
import { NorthvillePrograms } from './northville/NorthvillePrograms';
import { NorthvilleScheduleLocation } from './northville/NorthvilleScheduleLocation';
import { NorthvilleReviews } from './northville/NorthvilleReviews';
import { NorthvilleFAQHeader } from './northville/NorthvilleFAQHeader';
import { NorthvilleFAQQuestions } from './northville/NorthvilleFAQQuestions';
import { NorthvilleLinks } from './northville/NorthvilleLinks';
import { NorthvilleFinalCTA } from './northville/NorthvilleFinalCTA';
export function Northville() {
  useEffect(() => {
    document.title = 'Martial Arts & Taekwondo Near Northville, MI | Storm';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Storm Taekwondo serves Northville families with premium kids, adult, and family martial arts classes. Claim your free one-week trial.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Storm Taekwondo serves Northville families with premium kids, adult, and family martial arts classes. Claim your free one-week trial.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2576">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2577">
        <div className="absolute inset-0 opacity-20" data-id="element-2578">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2579" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2580" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2581">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2582">
            <NorthvilleHeroInfo data-id="element-2583" />
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2584">
              <NorthvilleHeroForm data-id="element-2585" />
            </div>
          </div>
        </div>
      </section>

      <NorthvilleDistance data-id="element-2586" />
      <NorthvilleWhy data-id="element-2587" />
      <NorthvillePrograms data-id="element-2588" />
      <NorthvilleScheduleLocation data-id="element-2589" />
      <NorthvilleReviews data-id="element-2590" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-2591">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2592">
          <NorthvilleFAQHeader data-id="element-2593" />
          <NorthvilleFAQQuestions data-id="element-2594" />
        </div>
      </section>
      <NorthvilleLinks data-id="element-2595" />
      <NorthvilleFinalCTA data-id="element-2596" />
    </div>;
}